export default __webpack_public_path__ + "static/media/head01_vi_pc@2x.7b1a9d3f.png";